"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toKeynumbersSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var theme_colors_1 = require("../constants/theme-colors");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toKeynumbersSlice = function (data, logger) {
    var _a, _b;
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.KeyNumbers)), { intro: logger.required(fields_1.toRichText((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.intro, logger)), text: logger.required(fields_1.toRichText((_b = data === null || data === void 0 ? void 0 : data.primary) === null || _b === void 0 ? void 0 : _b.text, logger)), keyNumbers: data === null || data === void 0 ? void 0 : data.items.map(function (item) { return ({
            number: logger.required(fields_1.toText(item.number)),
            description_first: logger.required(fields_1.toText(item.description_1)),
            description_second: fields_1.toText(item.description_2),
            animate: logger.required(fields_1.toBoolean(item.animate)),
            themeColor: theme_colors_1.toThemeColor(item.themeColor, logger)
        }); }) }));
};
exports.toKeynumbersSlice = toKeynumbersSlice;
//# sourceMappingURL=key-numbers-slice.js.map